import { extend } from 'lodash';

const SET_TOP_SERVICE = (state, topServiceCategoryGroup) => {
  state.topServiceCategoryGroup = topServiceCategoryGroup;
};

const SET_SELECTED_SERVICES = (state, payload) => {
  state.selectedServices = payload;
};

const ADD_SERVICE = (state, service) => {
  for (let i = 0; i < state.selectedServices.length; i++) {
    // if service is already in the selectedService arr, do nothing
    if (state.selectedServices[i].id === service.id) return;
  }
  state.selectedServices.push(service);
};

const REMOVE_SERVICE = (state, service) => {
  const index = state.selectedServices.findIndex(serviceItem => serviceItem.externalId === service.externalId);
  if (index !== -1) {
    state.selectedServices.splice(index, 1);
  }
};

const ADD_MAINTENANCE_POSITIONS_TO_SERVICE = (state, payload) => {
  // add maintenance positions to the selected service
  for (let i = 0; i < state.selectedServices.length; i++) {
    if (state.selectedServices[i].id === payload.serviceId) {
      extend(state.selectedServices[i], {
        dvnConfigs: [
          { maintenancePositions: payload.maintenancePositions }
        ]
      });
      break;
    }
  }
};

const REMOVE_MAINTENANCE_POSITIONS = (state, payload) => {
  // remove maintenance positions for the removed service
  state.maintenancePositions = state.maintenancePositions.filter(obj => obj.serviceId !== payload.id);
};

const SET_MAINTENANCE_POSITIONS = (state, payload) => {
  state.maintenancePositions = payload;
};

export default {
  SET_TOP_SERVICE,
  SET_SELECTED_SERVICES,
  ADD_SERVICE,
  REMOVE_SERVICE,
  ADD_MAINTENANCE_POSITIONS_TO_SERVICE,
  REMOVE_MAINTENANCE_POSITIONS,
  SET_MAINTENANCE_POSITIONS
}
